import {
  Avatar,
  InteractionTag,
  InteractionTagPrimary,
  Overflow,
  OverflowItem,
  TagGroup,
} from "@fluentui/react-components";
import { useAtom } from "jotai";
import { formatFullNameShort } from "library/utils";
import { selectedPackageUserAtom } from "store/UIBenefitsPage";
import styled, { useTheme } from "styled-components";

import { useIsMobile } from "hooks/useIsMobile";

import { OverflowMenu } from "./OverflowMenu";

export const SelectionTags = ({ options }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const [selectedUser, setSelectedUser] = useAtom(selectedPackageUserAtom);
  const defaultItems: any[] = options.map((option) => ({
    value: option.value,
    children: formatFullNameShort({
      firstName: option.firstName,
      lastName: option.lastName,
    }),
    data: option,
    media: (
      <Avatar
        shape="circular"
        aria-hidden="true"
        // name={`${option.firstName} ${option.lastName}`}
        image={{
          src: option?.backgroundPicturePath,
        }}
      />
    ),

    // secondaryText: option.employeeDependentTag ? "Dependent" : "Employee",
  }));

  return (
    <Container>
      <Overflow minimumVisible={isMobile ? 2 : 4} padding={60}>
        <TagGroup
          data-help="benefits-person-select"
          style={{
            display: "flex",
          }}
          aria-label="Overflow example"
        >
          {defaultItems.map((option) => {
            const selectedOption = selectedUser?.value === option.value;

            return (
              <OverflowItem key={option.value.toString()} id={option.value.toString()!}>
                <InteractionTag
                  key={option.value.toString()}
                  shape="circular"
                  style={{
                    border: `1px solid ${
                      selectedOption ? theme.palette.purpleDark : theme.palette.neutralLight
                    }`,
                  }}
                  onClick={() => {
                    setSelectedUser(option.data);
                  }}
                >
                  <InteractionTagPrimary
                    {...option}
                    style={{
                      background: selectedOption ? theme.palette.purpleLight : theme.palette.white,
                    }}
                  />
                </InteractionTag>
              </OverflowItem>
            );
          })}
          <OverflowMenu defaultItems={defaultItems} />
        </TagGroup>
      </Overflow>
    </Container>
  );
};

const Container = styled.div`
  overflow: hidden;
  z-index: 0; // stop the browser resize handle from piercing the overflow menu
  height: fit-content;
  min-width: 150px;
  resize: horizontal;
  width: 100%;
  box-sizing: border-box;

  .fui-InteractionTagPrimary__primaryText {
    font-weight: 500;
  }
`;
